import React from "react";
import "./style.scss";

const CODIcon = ({ className = "", style = {} }) => {
  return (
    <div className={`cod-icon cod-icon--default ${className}`} style={style} />
  );
};

export const CODIconFilled = ({ className = "", style = {} }) => {
  return (
    <div className={`cod-icon cod-icon--filled ${className}`} style={style} />
  );
};

export default CODIcon;
